import Tree from '../assets/Tree.jpg';
import money from '../assets/money.jpg';
import movie from '../assets/movie.jpg';
import youtube from '../assets/youtube.png';



export const projectList = [

   {
    name: 'Youtube Clone',
    image: youtube,
    Skills: 'HTML, CSS, JavaScript, React Js, API, Axios, Material UI',
    github: "https://github.com/UIET-Saurav-Kumar/youtube_clone",
    see: "https://647733e206c680108f070b06--golden-ganache-590ca3.netlify.app/"
   },
   {
      name: 'Movie Info Site',
      image: movie,
      Skills: 'HTML, CSS, JavaScript, ReactJs',
      github: "https://github.com/UIET-Saurav-Kumar/Movie__Site",
      see: "https://boisterous-druid-d91784.netlify.app/"
   },
   {
    name: 'Farmer Trust',
    image: money,
    Skills: 'HTML, CSS, JavaScript, PHP , SQL, Firebase',
    github: "https://github.com/UIET-Saurav-Kumar/Farmer_trust",
    see: "https://monumental-naiad-bff8cd.netlify.app/",
   },
   {
      name: 'Weather Info',
      image: Tree,
      Skills: 'HTML, CSS, JavaScript, API',
      github: "https://github.com/UIET-Saurav-Kumar/weather-info",
      see: "https://weather-info-saurav.netlify.app/"
     }






]